/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Compliance_Delete_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{title}\"? This action cannot be undone." |
*
* @param {Compliance_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_delete_description = /** @type {((inputs: Compliance_Delete_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Delete_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bist du sicher, dass du "${i?.title}" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.title}"? This action cannot be undone.`)
});